import { Context } from "@nuxt/types";

import Api from "@/utils/api";

export default class FollowerApi extends Api {
  readonly url = "/v2/recommended_profiles/";

  constructor($axios: Context["$axios"]) {
    super("followerService", $axios);
  }

  async getRecommenedProfile(limit: number) {
    return await this.request<ManyProfilesResponse>({
      method: "GET",
      params: {
        limit,
      },
    });
  }
}
